import styled from 'styled-components';
import Text from '@text';
import styleUtils from '../../styles/style.utils';
import themedColor from '../../styles/theme/themed-color';
import themedFontSize from '../../styles/theme/themed-font-size';

const SmartFaqArea = styled.div`
  padding: 0 ${styleUtils.px(16)};

  .question-list-title {
    border-bottom: solid 1px ${themedColor('TEXT_BLUE')};
    font-size: ${themedFontSize('BODY')};
    font-weight: 600;
    color: ${themedColor('TEXT_BLUE')};
    padding: ${styleUtils.px(16)} 0;
    background: none;
  }

  ul.question-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    background: none;

    & > li.question-list-item {
      padding-bottom: ${styleUtils.px(24)};
      padding-left: 0;
      border-bottom: solid 1px ${themedColor('TEXT_BLUE')};
      position: relative;
      background: none;
      list-style-type: none;

      &:after {
        width: ${styleUtils.px(12)};
        height: ${styleUtils.px(12)};
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: rotate(45deg) translate(-16px, 6px);
        border-right: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
        border-top: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
      }

      &.open {
        &:after {
          transform: rotate(135deg) translate(16px, 6px);
          top: 16px;
        }
      }

      .question-item-title {
        border: none;
        padding: 0;
        background: ${themedColor('WHITE')};
        color: ${themedColor('FAQ_TITLE')};
        font-size: ${themedFontSize('FORM')};
        font-weight: 700;
        cursor: pointer;
        text-align: left;
      }

      button {
        border: none;
        background: transparent;
        color: ${themedColor('TEXT_BLUE')};
        font-size: ${themedFontSize('FORM')};
        font-weight: 700;
        cursor: pointer;
        text-align: left;
        padding: ${styleUtils.px(24)} ${styleUtils.px(48)} 0 0;
        display: block;
        width: 100%;
        position: relative;
        z-index: 2;

        &:focus {
          border: none;
          outline: none;
        }

        &:hover {
          text-decoration: underline;
        }
      }

      .response-content {
        margin-top: ${styleUtils.px(24)};
        font-size: ${themedFontSize('FORM')};
        color: ${themedColor('TEXT_BLUE')};
        padding-right: ${styleUtils.px(48)};

        b,
        strong {
          font-weight: 700;
          font-size: ${themedFontSize('BODY')};
        }
        a {
          text-decoration: underline;
          font-size: ${themedFontSize('BODY')};
        }
        p {
          margin: ${styleUtils.px(16)} 0;
          font-size: ${themedFontSize('BODY')};
        }
      }
    }
  }
`;

interface FaqContainerProps {
  isHidden: boolean;
}
const FaqContainer = styled.div<FaqContainerProps>`
  display: ${({ isHidden }: FaqContainerProps): string =>
    isHidden ? 'none' : 'block'};
`;

const LinkContainer = styled.div`
  padding: 0 0 ${styleUtils.px(16)} 0;
  &:hover {
    a {
      text-decoration: underline;
      text-decoration-color: ${themedColor('TEXT_BLUE')};
    }
  }
`;

const AdditionalLink = styled.a`
  border-bottom: solid 1px ${themedColor('TEXT_BLUE')};
  padding: ${styleUtils.px(24)} ${styleUtils.px(48)} ${styleUtils.px(24)} 0;
  position: relative;
  display: block;
  text-decoration: none;

  &:after {
    width: ${styleUtils.px(12)};
    height: ${styleUtils.px(12)};
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: rotate(45deg) translate(-16px, 6px);
    border-right: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
    border-top: ${styleUtils.px(2)} solid ${themedColor('TEXT_BLUE')};
  }
`;

const StyledLinkText = styled(Text)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('FORM')};
    font-weight: 700;
    color: ${themedColor('FAQ_TITLE')};
    margin-bottom: 0;
  }
`;

const SmartFaqComponents = {
  FaqContainer,
  SmartFaqArea,
  AdditionalLink,
  StyledLinkText,
  LinkContainer
};

export default SmartFaqComponents;
